/**
 * VimeoPlayer functionality
 * @class
 */
export default class VimeoPlayer {
    /**
     * @constructor
     * @param {HTMLElement} element The video root element
     */
    constructor(element, videoId) {
        /**
         * Dispatch the broadcast event.
         *
         * This is used to pause any other videos that are playing on the page.
         *
         * @param {int} eventData
         *   The player state.
         */
        this.dispatchBroadcastEvent = (eventData) => {
            const broadcastEvent = new Event('videoPlayerStateChange');
            broadcastEvent.playerState = eventData;
            broadcastEvent.playerVideoId = this.id;
            document.body.dispatchEvent(broadcastEvent);
        };
        /**
         * Handle the global player state change event.
         *
         * @param {Event} event
         *   A triggered `videoPlayerStateChange` event.
         */
        this.handleGlobalVideoPlayerStateChange = (event) => {
            if (event.playerVideoId !== this.id && this.player) {
                this.player.pause();
            }
        };
        this.el = element;
        this.id = videoId;
        this.components = {
            poster: this.el.querySelector('[data-component="VideoPoster"]'),
            player: this.el.querySelector('[data-component="VideoPlayer"]')
        };
        if (this.components.poster) {
            this.components.poster.addEventListener('click', this.handlePosterClick.bind(this));
        }
        this.registerEvents();
        // console.log('VimeoPlayer', this)
    }
    /**
     * Handle the poster click event.
     */
    handlePosterClick() {
        if (!this.player) {
            this.playerCreate(1);
        }
    }
    /**
     * Create the YT player object.
     *
     * @param {int} autoPlay
     *   An integer indicating whether the player should start playing once created.
     */
    playerCreate(autoPlay) {
        if (this.components.player) {
            // @ts-ignore
            this.player = new window.Vimeo.Player(this.components.player, {
                id: parseInt(this.id),
                responsive: true
            });
        }
        this.player.on('play', this.playerPlay.bind(this));
        //   this.player.on('ended', this.playerEnded.bind(this))
        if (autoPlay) {
            this.player.play();
        }
    }
    playerPlay(event) {
        this.dispatchBroadcastEvent(event);
    }
    /**
     * Register the required event listeners
     */
    registerEvents() {
        document.body.addEventListener('videoPlayerStateChange', this.handleGlobalVideoPlayerStateChange.bind(this));
    }
}
